webpackJsonp([660921399466],{

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuienesSomos = function QuienesSomos() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '\xBFQu\xE9 es Gasred?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Sistema de monedero electr\xF3nico autorizado por el SAT que permite administra y controlar el consumo de combustible.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Visi\xF3n'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Empresa l\xEDder en el noroeste del pa\xEDs, en sistemas de control del combustible.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Misi\xF3n'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Elevarla productividad en el consumo de combustible, a trav\xE9s de sistemas de control eficiente, satisfaciendo las m\xE1s altas expectativas de nuestros clientes, colaboradores y accionistas.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Valores'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Disponibilidad'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Mejora continua'
	      ),
	      ' ',
	      _react2.default.createElement(
	        'li',
	        null,
	        'Empat\xEDa '
	      ),
	      ' ',
	      _react2.default.createElement(
	        'li',
	        null,
	        'Trabajo en equipo '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Servicio Responsabilidad'
	      )
	    )
	  );
	};
	
	exports.default = QuienesSomos;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quienes-somos-js-776e46e456c0c343c4dc.js